import { render, staticRenderFns } from "./ArchiveAssessmentButton.vue?vue&type=template&id=007e514e&"
import script from "./ArchiveAssessmentButton.vue?vue&type=script&lang=js&"
export * from "./ArchiveAssessmentButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports